import type { ImportedDeck } from "src/helpers/flashcards/ankiImport";

export interface SpreadsheetFile {
	// Nazwa pliku bez rozszerzenia — domyślna nazwa zestawu przy imporcie wielu plików.
	name: string;
	fileName: string;
	size: number;
	rows: string[][];
}

export interface AnkiFile {
	fileName: string;
	size: number;
	decks: ImportedDeck[];
}

export interface ImportFormValues {
	// Indeks kroku steppera: CSV 0 plik → 1 kolumny → 2 podgląd; Anki 0 plik → 1 podgląd.
	step: number;
	// CSV/XLSX — surowe wiersze; kolumny wyliczane na bieżąco (zależą od hasHeader).
	files: SpreadsheetFile[];
	// Anki/TXT — gotowe fiszki, bez mapowania kolumn.
	anki: AnkiFile | null;
	hasHeader: boolean;
	// Indeksy kolumn (mapowanie z pierwszego pliku stosowane do wszystkich); -1 = brak.
	frontColumn: number;
	backColumn: number;
	deckNameColumn: number;
	deckDescriptionColumn: number;
	isParsing: boolean;
}

export const initialValues: ImportFormValues = {
	step: 0,
	files: [],
	anki: null,
	hasHeader: true,
	frontColumn: 0,
	backColumn: 1,
	deckNameColumn: -1,
	deckDescriptionColumn: -1,
	isParsing: false,
};
